import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Modal from 'components/modal';

import AvailableOptions from './options/available';
import Cards from 'bundles/apex/card/container';
import SelectedOptions from './options/selected';
import SettingsContext from './settings_context';

import './styles.scss';

export default function MultiselectModal({
  allowEmptySelection,
  closeOnSave = true,
  defaultValue = [],
  eventName,
  hideSearch,
  optionLabelName = 'label',
  options,
  optionsLabel,
  optionValueName = 'value',
  reorderable,
  saveButtonLabel = 'Save',
  show,
  title,
  value,
  onClose,
  onSave,
}) {
  const [selection, setSelection] = useState(defaultValue);

  useEffect(() => {
    if (show && value !== undefined) {
      setSelection(value);
    }
  }, [show]);

  function submit() {
    if (eventName) {
      window.dispatchEvent(new CustomEvent(eventName, { detail: { value: selection } }));
    }

    if (onSave) {
      onSave(selection);
    }

    if (closeOnSave) {
      onClose();
    }
  }

  return (
    <Modal className="multiselect-modal" show={show} onHide={onClose}>
      <Modal.Header closeButton>
        {title}
      </Modal.Header>

      <Modal.Body>
        <Cards className="flex-1 w-100">
          <SettingsContext.Provider value={{ optionLabelName, optionValueName }}>
            <AvailableOptions
              hideSearch={hideSearch}
              options={options}
              optionsLabel={optionsLabel}
              selection={selection}
              onAdd={added => setSelection([...selection, added])}
              onAddAll={() => setSelection(options)}
            />

            <SelectedOptions
              options={options}
              optionsLabel={optionsLabel}
              reorderable={reorderable}
              selection={selection}
              onChange={setSelection}
            />
          </SettingsContext.Provider>
        </Cards>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel className="mr-2" onClick={onClose}/>
        <Button.Primary disabled={!allowEmptySelection && !selection.length} onClick={submit}>
          {saveButtonLabel}
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

MultiselectModal.propTypes = {
  allowEmptySelection: PropTypes.bool,
  closeOnSave: PropTypes.bool,
  defaultValue: PropTypes.array,
  eventName: PropTypes.string,
  hideSearch: PropTypes.bool,
  optionLabelName: PropTypes.string,
  options: PropTypes.array.isRequired,
  optionsLabel: PropTypes.string,
  optionValueName: PropTypes.string,
  reorderable: PropTypes.bool,
  saveButtonLabel: PropTypes.string,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  value: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
};
